import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `SystemTemplatesTabPage`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "SystemTemplates" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
